module.exports = require('./node_modules/jquery');


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery.2/index.js
// module id = D3Zg
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11